import { Box, Dialog, DialogContent, Fade, Modal, Skeleton, Stack } from '@mui/material'
import { AlreadyAccount } from 'Components/Elements/SignUp/SignUp'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import { observer } from 'mobx-react-lite'
import { Suspense, useEffect, useMemo, useState } from 'react'
import Login from '../../Elements/Login/Login'
import { lazy } from 'react'
import pMinDelay from 'p-min-delay'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import styled from '@emotion/styled'
import MoneyBack from 'Components/Elements/Checkout/MoneyBack'
import { DefaultButton } from 'Components/Elements/Forms'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import PaymentForm from 'Components/Elements/Checkout/ShippingAddressForm/Country/Morocco/PaymentForm'
import { isSomething } from 'Utils/Utils'
import Checkout from 'GlobalStores/Checkout/Country/Checkout'
import storeFormat from 'GlobalStores/Format/StoreFormat'
import { get } from 'lodash'

import { useLocation, useNavigate } from 'react-router-dom'
import StoreLoader from 'GlobalStores/Cores/Elements/StoreLoader'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import PaymentHydraForm from 'Components/Elements/Checkout/ShippingAddressForm/Country/PaymentHydraForm'
import ReCaptchaV3 from 'Components/Elements/ReCaptcha/ReCaptchaV3'
import DuplicatedOrder from 'Components/Elements/DuplicatedOrder/DuplicatedOrder'
import { storeElement } from 'GlobalStores/StoreElement'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { runInAction } from 'mobx'

const PreSummaryBoxLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/PreSummaryBox'), 0))
const JordanCreateAccountWithShippingLazyLoad = lazy(() =>
    pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Jordan/JordanCreateAccountWithShipping'), 0)
)
const JordanShippingAddressLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Jordan/JordanShippingAddress'), 0))

const JordanPaymentLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Jordan/JordanPayment'), 0))

const JordanCheckoutTheme = observer(({ Sections, step, onPlaceOrder, openLoginModal, setOpenLoginModal }) => {
    const translate = useTranslate()
    const { width } = useSizeWindow()
    const [dataPayment, setDataPayment] = useState({})
    const [loading, setLoading] = useState(false)
    const [sectionReady, setSectionReady] = useState(false)
    const [openDuplicatedModal, setOpenDuplicatedModal] = useState(false)
    const [duplicatedData, setDuplicatedData] = useState({
        paymentId: '',
        dateAndTime: '',
        totalPrice: '',
        currency: '',
        is_duplicate: false
    })

    const location = useLocation()

    const qs = useMemo(() => new URLSearchParams(window.location.search), [])

    const shippingPaymentOption = StoreCheckout.GetShippingPaymentOption()

    const [dataRedirectToPayment, setDataRedirectToPayment] = useState()

    const navigate = useNavigate()

    useEffect(() => {
        setLoading(false)
    }, [])

    const ThemeSections = step => {
        switch (step) {
            case 'payment':
                return <JordanPaymentLazyLoad onPlaceOrder={onPlaceOrder} sectionReady={setSectionReady} />
            case 'create-account':
                return <JordanCreateAccountWithShippingLazyLoad sectionReady={setSectionReady} />
            default:
                return <JordanShippingAddressLazyLoad sectionReady={setSectionReady} />
        }
    }

    const submitRedirectPayment = async () => {
        setLoading(true)
        if (StoreCheckout.CheckOutInstance().Instance().PaymentGateway === 'hydra3ds') {
            const checkout = new Checkout()
            let items = []
            storeFormat.GetFormatData('formatProducts').map(item => {
                items.push({
                    item_id: item.item_code,
                    item_name: item.item_name.english + ' ' + item.item_name.english,
                    price: item.baStatus === 'C' ? item.retail_price_x_qty.value : item.price_x_qty.value
                })
            })

            try {
                const response = await checkout.SubmitPayment(
                    StoreCheckout.GetUuid(),
                    storeFormat.GetDetailPage(),
                    {},
                    StoreCheckout.GetBillingAddressForm(),
                    items,
                    {
                        shippingPaymentOption: StoreCheckout.GetShippingPaymentOption(),
                        totalPrice: StoreCheckout.TotalPrice()
                    }
                )

                if (response.orderData.transactions.items.length > 1) {
                    const dataPrepareToForm = response.orderData.transactions.items.find(item => item.method === 'CreditCard')
                    if (dataPrepareToForm) {
                        setDataRedirectToPayment({
                            formMethod: get(dataPrepareToForm, 'methodDetails.iouReceipt.method'),
                            formAction: get(dataPrepareToForm, 'methodDetails.iouReceipt.url'),
                            formData: get(dataPrepareToForm, 'methodDetails.iouReceipt.data')
                        })
                    }
                } else {
                    setDataRedirectToPayment({
                        formMethod: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.method') || "POST",
                        formAction: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.url'),
                        formData: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.data')
                    })
                }
            } catch (e) {
                console.log('error', e)
            }
        } else {
        }
    }

    const closeDuplicateModal = () => {
        setOpenDuplicatedModal(false)
        runInAction(() => {
            storeElement.showCardFrontDrop = false
        })
    }

    const confirmPlaceOrder = async () => {
        setOpenDuplicatedModal(false)
        runInAction(() => {
            StoreCheckout.paymentErrors = []
            storeElement.showCardFrontDrop = true
        })
        await submitRedirectPayment()
    }

    const onClickPlaceOrder = async () => {
        const pathname = location.pathname
        const BreadcrumbStep = StoreCheckout.CheckOutInstance().GetBreadcrumbOption()
        const paymentStep = BreadcrumbStep.findIndex(item => item.link === pathname)
        const lastStep = paymentStep === BreadcrumbStep.length - 1

        if (lastStep) {
            const responseDuplicateOrder = await checkDuplicateOrder()

            if (responseDuplicateOrder.isDuplicate) {
                return
            } else {
                await submitRedirectPayment()
            }
        } else {
            await submitRedirectPayment()
        }
    }

    const checkDuplicateOrder = async () => {
        try {
            runInAction(() => {
                StoreCheckout.paymentErrors = []
                storeElement.showCardFrontDrop = true
            })
            const checkDuplicateOrder = await FormatAPIs.checkDuplicateOrder({
                countryCode3Alpha: storeCountry.Country3(),
                uuid: StoreCheckout.GetUuid() || qs.get('uuid')
            })

            if (checkDuplicateOrder.data.is_duplicate === true) {
                setDuplicatedData({
                    paymentId: checkDuplicateOrder.data.payments_id,
                    dateAndTime: checkDuplicateOrder.data.date_time,
                    totalPrice: checkDuplicateOrder.data.total_price,
                    is_duplicate: true,
                    currency: checkDuplicateOrder.data.currency || storeCountry.GetCurrencyCode()
                })
                setOpenDuplicatedModal(true)
            } 

            return {
                isDuplicate: checkDuplicateOrder.data.is_duplicate
            }
        } catch (e) {
            console.log('error', e)
            closeDuplicateModal()
        }
    }

    const extendPlaceOrder = () => {
        return (
            <Stack alignItems={'center'}>
                <DefaultButton
                    titleText={translate('proceed_to_payment')}
                    disabled={loading || shippingPaymentOption === null}
                    onClick={onClickPlaceOrder}
                    width={width > 700 ? '340px' : '100%'}
                    isloading={loading.toString()}
                    style={{ marginTop: '25px', fontSize: '18px' }}
                />
                <MoneyBack />
            </Stack>
        )
    }

    useEffect(() => {
        if (StoreLoader.IsFormatApiLoading() === true) {
            setSectionReady(false)
        }
    }, [StoreLoader.IsFormatApiLoading()])

    return (
        <MarStackStyled stepPaymentOrReview={step}>
            <Suspense fallback={<PageSkeletonSectionLazyLoad />}>
                <Stack>{ThemeSections(step)}</Stack>
            </Suspense>

            <Stack width={width > 1200 ? '380px' : 'auto'}>
                <Suspense fallback={<PageSkeletonSummaryElement />}>
                    <PreSummaryBoxLazyLoad
                        step={step}
                        edit={false}
                        isReady={StoreCheckout.isReadyToPlaceOrder}
                        onPlaceOrder={onPlaceOrder}
                        extendPlaceOrder={extendPlaceOrder}
                    />
                </Suspense>
            </Stack>

            {step === 'create-account' && (
                <>
                    <DesktopAlreadyAccount>
                        <AlreadyAccount setOpenLoginModal={setOpenLoginModal} />
                    </DesktopAlreadyAccount>

                    <Modal
                        open={openLoginModal}
                        onClose={() => {
                            if (StoreAuth.loadingLogin) return
                            setOpenLoginModal(false)
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description">
                        <Fade in={openLoginModal}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 'calc(50% - 40px)',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: '0px'
                                }}>
                                <Login showFooter={false} setOpenLoginModal={setOpenLoginModal} />
                            </Box>
                        </Fade>
                    </Modal>
                </>
            )}

            {step === 'payment' && (
                <DialogDuplicatedStyled open={openDuplicatedModal}>
                    <DialogContent
                        sx={{
                            padding: {
                                xs: '32px 24px',
                                md: '64px 93px'
                            }
                        }}>
                        <DuplicatedOrder confirmPlaceOrder={confirmPlaceOrder} setOpenModal={closeDuplicateModal} {...duplicatedData} />
                    </DialogContent>
                </DialogDuplicatedStyled>
            )}
            {isSomething(dataPayment) && (
                <div style={{ display: 'none' }}>
                    <PaymentForm dataPayment={dataPayment} />
                </div>
            )}
            {dataRedirectToPayment && (
                <div style={{ display: 'inherit' }}>
                    <PaymentHydraForm dataPayment={dataRedirectToPayment} />
                </div>
            )}
        </MarStackStyled>
    )
})

const StackStyled = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;
    min-height: 50vh;
    display: flex;
    flex-direction: ${props => (props.stepPaymentOrReview ? 'column' : 'column-reverse')};
    justify-content: ${props => (props.stepPaymentOrReview ? 'flex-start' : 'flex-end')};
    gap: 20px;

    @media screen and (min-width: 399px) {
        padding-top: 40px;
    }

    @media screen and (min-width: 600px) {
        padding-top: 60px;
    }

    @media screen and (min-width: 1200px) {
        display: grid;
        grid-template-columns: 770px 370px;
        gap: 22px;
        padding-top: 40px;
    }
`

const MarStackStyled = styled(StackStyled)`
    flex-direction: ${props => (props.stepPaymentOrReview === 'payment' ? 'column' : 'column-reverse')};
    justify-content: ${props => (props.stepPaymentOrReview ? 'flex-start' : 'flex-end')};

    @media screen and (min-width: 768px) {
        padding-top: 40px;
        gap: 20px;
    }
`

const DesktopAlreadyAccount = styled('div')`
    display: block;
    @media screen and (min-width: 1200px) {
        display: none;
    }
`

const DialogDuplicatedStyled = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        box-shadow: none;
        @media screen and (min-width: 768px) {
            width: 100%;
            max-width: 650px;
        }
    }
`

const PageSkeletonSummaryElement = observer(props => {
    return (
        <Stack>
            <Skeleton
                variant="rounded"
                width={'100%'}
                sx={{
                    margin: '0',
                    borderRadius: '12px',
                    height: '370px',
                    // height: '108px',
                    // '@media screen and (min-width: 1200px)': {
                    //     height: '370px'
                    // }
                }}
            />
        </Stack>
    )
})

const PageSkeletonSectionLazyLoad = () => (
    <Stack>
        <Skeleton variant="rounded" width={'100%'} height={'700px'} sx={{ margin: '0', borderRadius: '12px' }} />
    </Stack>
)

export default JordanCheckoutTheme
